import { render } from "./NumericValue.vue?vue&type=template&id=08985c3c"
import script from "./NumericValue.vue?vue&type=script&lang=js"
export * from "./NumericValue.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__